import React from 'react'
import { BBDTag, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { WarningFilled } from '@ant-design/icons'
import type { ICellRendererParams } from 'ag-grid-community'

interface InvoiceCountCellRendererProps extends ICellRendererParams {
  data: {
    totalInvoices: number
    totalBOLs: number
  }
}

export function InvoiceCountCellRenderer(params: InvoiceCountCellRendererParams) {
  const { data } = params
  const invoiceCount = data?.totalInvoices || 0
  const bolCount = data?.totalBOLs || 0

  const shouldShowWarning = invoiceCount !== bolCount && invoiceCount > bolCount

  if (shouldShowWarning) {
    return (
      <Horizontal alignItems='center' justifyContent='center' style={{ height: '100%' }}>
        <BBDTag warning style={{ fontSize: '11px', padding: '2px 6px' }}>
          <Horizontal alignItems='center' gap={4}>
            <WarningFilled style={{ fontSize: 10 }} />
            <Texto appearance='default' style={{ fontSize: '11px' }}>
              {invoiceCount}
            </Texto>
          </Horizontal>
        </BBDTag>
      </Horizontal>
    )
  } else {
    return (
      <Horizontal alignItems='center' justifyContent='center' style={{ height: '100%' }}>
        <Texto style={{ fontSize: '12px' }}>{invoiceCount}</Texto>
      </Horizontal>
    )
  }
}
